<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout column wrap justify-center>
        <v-layout column class="ml-3">
          <v-text-field
              label="asd"
              v-model="value"
              @onChange="selectEmojiHandle()"
              @keyup.delete="deleteEmojiHandle($event)"
              style="display: hidden !important"
              ref="uploader"
            >
            </v-text-field>
            <br>
            <div style="width:90%; height:100px; border:1px solid black" v-on="listeners" v-html="divText" contenteditable="true"></div>
            <br>
            <v-btn
            @click="addEmoji"
            color="defaultColor"
            text
            small
            class="mr-2 text-capitalize"
          >
            Tüm
          </v-btn>
        </v-layout>

        <!-- <textarea ref="uploader" id="emojionearea1">Default :smile:</textarea> -->
        <!-- <v-layout>
          <div
            style="width: 200px; border: 1px solid red; margin-left: 100px"
            contenteditable="true"
            placeholder=""
            tabindex="0"
            dir="ltr"
            spellcheck="false"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            v-html="emojiText"
            
            id="editor"
          ></div>
          <br />
          <v-btn
            @click="addEmoji"
            color="defaultColor"
            text
            small
            class="mr-2 text-capitalize"
          >
            Tüm
          </v-btn>
        </v-layout> -->

        <!-- <v-layout column class="ml-6">
          <textarea
            v-model="inputText"
            @change="someHandler"
            id="emojionearea1"
            style="border: 1px solid red; width: 200px"
          >
Default :smile:</textarea
          >
          <div
            v-html="divText"
            style="border: 1px solid blue; width: 200px"
            contenteditable="true"
            tabindex="0"
            dir="ltr"
            spellcheck="false"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
          ></div>
        </v-layout> -->

        <!-- <v-layout>
          <div style="border:1px solid black; margin-left:200px; width:100px;" ref="editable" contenteditable v-on="listeners" v-html="value"></div>
          <v-btn
            @click="addEmoji"
            color="defaultColor"
            text
            small
            class="mr-2 text-capitalize"
          >
            Tüm
          </v-btn>
        </v-layout> -->

        <!-- <v-layout>
            <div v-html="emojiText"></div>
          </v-layout> -->
        <!-- <v-layout width="500" style="margin-left:500px">  <Emojionearea
      v-model="text"
      :search="false"
      style="width:400px"
      pickerPosition="left"
      :inline="true"
      :shortcuts=false
    ></Emojionearea></v-layout> -->

        <!-- <v-layout>
      <textarea id="example1"></textarea>
    </v-layout> -->

        <!-- <v-layout>
            <v-flex style="background-color: red; height: 200px">
                <picker :custom="customEmojis" />
            </v-flex>
          </v-layout> -->

        <!-- <v-layout>
            <img alt=':71:' title=':mermaid' :src="require('@/../public/images/emoji/41.png').default">
          </v-layout> -->
        <!-- Profile Card-->
        <!--<v-flex md3 class="hidden-sm-and-down" sticky-container>
           <div v-sticky sticky-offset="offsetProfile">
            <profile-card/>
          </div>
        </v-flex> -->

        <!-- <textarea id="example1" style="border: 1px solid red"></textarea> -->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// import dataa from './all.json'
// import { Picker, EmojiIndex } from 'emoji-mart-vue-fast',

// import { Picker } from "emoji-mart-vue";
// import dataaa from 'emoji-mart-vue/data/messenger.json'

export default {
  data: () => {
    return {
      inputText: "",
      divText: "",
      value:'',
      //   text: "",
      //   emojiText:
      //     "<img alt=':71:' width='50' heigth='50' title=':mermaid' src='http://web-bsp.s3-website-eu-west-1.amazonaws.com/img/bsp-logo.0ab49e94.png'>",
      //   oldValue: "",

      //   emojiData: {
      //     compressed: true,
      //     categories: [
      //       {
      //         id: "smileys",
      //         name: "Smileys & Emotion",
      //         emojis: ["zzz"],
      //       },
      //     ],
      //     emojis: {
      //       100: {
      //         subcategory: "emotion",
      //         a: "Hundred Points Symbol",
      //         b: "1F4AF",
      //         d: true,
      //         e: true,
      //         f: true,
      //         h: true,
      //         j: [
      //           "hundred_points",
      //           "score",
      //           "perfect",
      //           "numbers",
      //           "century",
      //           "exam",
      //           "quiz",
      //           "test",
      //           "pass",
      //           "hundred",
      //         ],
      //         k: [28, 6],
      //         o: 0,
      //       },
      //     },
      //     aliases: {
      //       satisfied: "laughing",
      //       grinning_face_with_star_eyes: "star-struck",
      //       grinning_face_with_one_large_and_one_small_eye: "zany_face",
      //       smiling_face_with_smiling_eyes_and_hand_covering_mouth:
      //         "face_with_hand_over_mouth",
      //       face_with_finger_covering_closed_lips: "shushing_face",
      //       face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
      //       face_with_open_mouth_vomiting: "face_vomiting",
      //       shocked_face_with_exploding_head: "exploding_head",
      //       serious_face_with_symbols_covering_mouth:
      //         "face_with_symbols_on_mouth",
      //       poop: "hankey",
      //       shit: "hankey",
      //       collision: "boom",
      //       raised_hand: "hand",
      //       hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
      //       sign_of_the_horns: "the_horns",
      //       reversed_hand_with_middle_finger_extended: "middle_finger",
      //       thumbsup: "+1",
      //       thumbsdown: "-1",
      //       punch: "facepunch",
      //       mother_christmas: "mrs_claus",
      //       running: "runner",
      //       "man-with-bunny-ears-partying": "men-with-bunny-ears-partying",
      //       "woman-with-bunny-ears-partying": "women-with-bunny-ears-partying",
      //       women_holding_hands: "two_women_holding_hands",
      //       woman_and_man_holding_hands: "man_and_woman_holding_hands",
      //       couple: "man_and_woman_holding_hands",
      //       men_holding_hands: "two_men_holding_hands",
      //       paw_prints: "feet",
      //       flipper: "dolphin",
      //       honeybee: "bee",
      //       lady_beetle: "ladybug",
      //       cooking: "fried_egg",
      //       knife: "hocho",
      //       red_car: "car",
      //       sailboat: "boat",
      //       waxing_gibbous_moon: "moon",
      //       sun_small_cloud: "mostly_sunny",
      //       sun_behind_cloud: "barely_sunny",
      //       sun_behind_rain_cloud: "partly_sunny_rain",
      //       lightning_cloud: "lightning",
      //       tornado_cloud: "tornado",
      //       tshirt: "shirt",
      //       shoe: "mans_shoe",
      //       telephone: "phone",
      //       lantern: "izakaya_lantern",
      //       open_book: "book",
      //       envelope: "email",
      //       pencil: "memo",
      //       heavy_exclamation_mark: "exclamation",
      //       staff_of_aesculapius: "medical_symbol",
      //       "flag-cn": "cn",
      //       "flag-de": "de",
      //       "flag-es": "es",
      //       "flag-fr": "fr",
      //       uk: "gb",
      //       "flag-gb": "gb",
      //       "flag-it": "it",
      //       "flag-jp": "jp",
      //       "flag-kr": "kr",
      //       "flag-ru": "ru",
      //       "flag-us": "us",
      //     },
      //   },
      //   focusIn: false,
      //   valueText: "",

      //   //////

      //   tempText: "",
      //   customEmojis: [
      //     {
      //       name: ":71:",
      //       short_names: [":71:"],
      //       text: "",
      //       emoticons: [],
      //       keywords: ["BAT"],
      //       imageUrl:
      //         "http://web-bsp.s3-website-eu-west-1.amazonaws.com/img/bsp-logo.0ab49e94.png",
      //     },
      //   ],
      oldValue:'',
      newValue:'',
    };
  },
  components: {},
  methods: {
    onInput(e) {
        console.log('target :' , e.target.innerText)
        // this.newVal =  e.target.innerText
        // if(this.oldVal != this.newVal){
        //     this.oldVal = this.newVal
        // }else{
        //     console.log('oldVal : ', this.oldVal)
        // }
      this.value=e.target.innerText
    },
    someHandler() {
      //console.log("change:", this.inputText);
    },
    selectEmojiHandle() {
      //console.log("e :", this.text);
      let bat =
        "<img alt=':71:' width='50' heigth='50' title=':mermaid' src='http://web-bsp.s3-website-eu-west-1.amazonaws.com/img/bsp-logo.0ab49e94.png'>";
      let divText = this.divText.replaceAll(":71:", bat);
      this.divText = divText;
    },

    update(e) {
      //this.localValue = e.target.innerHTML;
    },
    focus() {
      this.focusIn = true;
    },
    blur() {
      this.focusIn = false;
    },

    addEmoji() {
    //   this.selectEmojiHandle();
    //   const input = document.getElementById("editor");
    
    let bat =
        "<img alt=':71:' width='50' heigth='50' title=':mermaid' src='http://web-bsp.s3-website-eu-west-1.amazonaws.com/img/bsp-logo.0ab49e94.png' />";
        //console.log("add emoji:", bat);
        console.log("add value", this.divText);
        this.value= this.value + ':71:'
        //this.divText = this.divText.concat(bat).toString();
        
        //console.log("add value2", this.divText);

    //   console.log("text :", text);
    //   input.innerHTML = text;
    },

    deleteEmojiHandle(event) {
      console.log("event :", event);
      console.log("event code:", event.code);
      console.log(
        "event value:",
        event.target.value[event.target.value.length - 1]
      );
      console.log("event old value:", this.oldValue[this.oldValue.length - 1]);
      let control = this.oldValue[this.oldValue.length - 1];
      if (control == ":") {
        let a = this.oldValue[this.oldValue.length - 4];
        console.log("önceki : ", this.oldValue[this.oldValue.length - 4]);
        if (a == ":") {
          this.text = this.text.slice(0, -3);
          console.log("silindi : ", this.text);
        }
      }
    },

    updateCode: function ($event) {
      //below code is a hack to prevent updateDomProps
      this.$vnode.child._vnode.data.domProps["innerHTML"] =
        $event.target.innerHTML;
      this.$emit("input", $event.target.innerHTML);
    },
  },
  computed: {
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("update:value", newValue);
      },
    },
    listeners() {
      return { ...this.$listeners, input: this.onInput };
    },
  },
  mounted() {
    //this.$refs.editable.innerText = this.value;
    // const input = document.getElementById("editor");
    // input.addEventListener("input", updateValue);
    // let vm = this
    // function updateValue(e) {
    //   console.log('update:',e.target.innerText);
    //   vm.tempText = e.target.innerText
    //   console.log('temp :' , this.tempText)
    // }
    // $(document).ready(function () {
    //   $("#example1").emojioneArea({
    //     search: false,
    //     pickerPosition: "bottom",
    //     hidePickerOnBlur: false,
    //     tones: false,
    //     saveEmojisAs: "image",
    //     inline: true,
    //     shortcuts: false,
    //     filters: {
    //       recent: false, // disable recent
    //       activity: false,
    //       travel_places: false,
    //       smileys_people: false,
    //       animals_nature: false,
    //       symbols: false, // disable symbols filter
    //       flags: false, // disable flags filter
    //       objects: false,
    //       food_drink: {
    //         emoji: "smiley smile cat", // change emojis of the filter food_drink
    //       },
    //     },
    //   });
    // });
  },
  watch: {
    value: {
      //<-- Edited
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
        //console.log("change : ", newVal);
        if(newVal.includes(':71:')){
            console.log('easmoji var')
            let bat =
        "<img alt='' width='50' heigth='50' title=':mermaid' src='http://web-bsp.s3-website-eu-west-1.amazonaws.com/img/bsp-logo.0ab49e94.png' />";
    }
        
          //this.divText = newVal;
          //this.oldValue = oldVal;
          //this.selectEmojiHandle();
        }
      },
    },

    divText: {
      //<-- Edited
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          console.log("divText change : ", newVal);
          this.value=newVal
        //   this.divText = newVal;
        //   //this.oldValue = oldVal;
        //   this.selectEmojiHandle();
        if(newVal.includes(':71:')){
            console.log('easmoji var')
        }
        }
      },
    },

    localValue(newVal) {
      if (!this.focusIn) {
        this.valueText = newVal;
      }
    },
  },
};
</script>

<style></style>
